import * as z from "zod";
import { isValidVat } from "vat-number-validator";

export const NORWEGIAN_ORG_NUMBER_REGEX = /^\d{9}$/;

const PartnerSchema = z
  .object({
    orgNumber: z.string().trim().min(1, "validation:orgNumberRequired"),
    companyName: z.string().min(0),
    country: z.string().min(1, "validation:countryRequired"),
    address: z.string().min(0),
    city: z.string().min(0),
    region: z.string().min(0),
    postalCode: z.string().min(0),
    duns: z.string().min(1, "validation:dunsRequired").regex(/^\d+$/, "validation:invalidDuns"),
    contractTemplateIds: z.array(z.string()),
    isNorwegian: z.boolean(),
    outsideEu: z.boolean(),
  })
  .superRefine((data, ctx) => {
    const orgNumber = data.orgNumber.replace(/\s/g, "");
    if (!orgNumber) return;

    const addOrgNumberIssue = (message: string) =>
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["orgNumber"], message });

    if (data.isNorwegian) {
      if (!NORWEGIAN_ORG_NUMBER_REGEX.test(orgNumber)) {
        addOrgNumberIssue("validation:norwegianOrgNumberLength");
      }
      return;
    }

    if (data.outsideEu) return;

    if (!isValidVat(orgNumber.toUpperCase())) {
      addOrgNumberIssue("validation:invalidOrgNumber");
    }
  });

export const AddPartnerValidationSchema = PartnerSchema;
export type AddPartnerFormInput = z.infer<typeof PartnerSchema>;
